<template>
  <Dialog
    :visible="visible"
    :modal="true"
    :dismissableMask="false"
    :class="'mx-auto w-full max-w-md'"
    @update:visible="onModalVisibilityChange"
  >
    <template #header>
      <div class="text-center mx-auto">
        <span class="font-bold text-xl align-middle">Password Reset</span>
      </div>
    </template>
    <div class="w-[90%] align-middle mx-auto">
      <RMSInputText
        :fieldId="'email_or_username'"
        :config="{ label: 'Email or Username' }"
        @onValidInput="onValidInputUsername"
        @onClear="onClearInputUsername"
      />
      <div class="pt-6 pb-2">
        <button
          :disabled="!isFormValid"
          class="w-full reset-via-email-button font-medium"
          @click="onSubmit"
        >Reset via Email
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { computed, ref } from 'vue'
import AuthenticationService from '@/services/auth/AuthenticationService'
import Dialog from 'primevue/dialog'
import RMSInputText from '@/components/fields/RMSInputText.vue'
import authenticationErrors from '@/contracts/AuthenticationErrors'
import { useToast } from 'primevue/usetoast'

export default {
  components: {
    RMSInputText,
    Dialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'onPasswordReset',
    'onClose',
  ],
  setup(props, { emit }) {
    const toast = useToast()
    const authenticationService = new AuthenticationService()
    const formData = ref({
      email_or_username: undefined,
    })
    const isFormValid = computed(() => {
      return !!formData.value.email_or_username
    })

    const onValidInputUsername = (value) => formData.value.email_or_username = value
    const onClearInputUsername = () => formData.value.email_or_username = undefined

    const onModalVisibilityChange = () => emit('onClose')
    const onSubmit = () => {
      authenticationService.forgotPassword(formData.value)
        .then(response => !!response.success ? emit('onPasswordReset') : showError(response))
        .catch((error) => showError(error.response))
    }

    /**
     * @param {object} response
     */
    const showError = (response) => {
      let detail, severity, summary, life
      if (!!response.code) {
        switch (response.code) {
          case authenticationErrors.FailedUserLookup:
            severity = 'info'
            summary = ''
            detail = 'The provided credentials do not match our records.'
            life = 3000
            break
          case authenticationErrors.FailedPasswordResetSend:
            severity = 'error'
            summary = 'Error'
            detail = 'An attempt to send a password reset email has failed. Please contact your system administrator.'
            life = undefined
            break
          default:
            severity = 'error'
            summary = 'Error'
            detail = 'An error has occurred. Please contact your system administrator.'
            life = 3000
            break
        }
      } else if (!!response?.data?.message) {
        severity = 'error'
        summary = 'Error'
        detail = response?.data?.message
        life = 3000
      }
      toast.add({
        severity: severity,
        summary: summary,
        detail: detail,
        life: life,
      })
    }

    return {
      onModalVisibilityChange,
      onValidInputUsername,
      onClearInputUsername,
      onSubmit,
      isFormValid,
    }
  },
}
</script>
<style lang="scss">

.reset-via-email-button,
.reset-via-email-button:disabled,
.reset-via-email-button:hover {
  border-radius: 3px;
  background-color: #0a6f3f;
  color: white;
  font-size: 1rem;
  height: 3.6rem;
}

.reset-via-email-button:disabled {
  opacity: 1;
}

.reset-via-email-button:hover {
  opacity: 0.95;
}

</style>
